export const getAverageAge = (ages: number[]) => {
    const sum: number = ages.reduce((accumulator: number, currentAge: number) => accumulator + currentAge, 0);
    // Calculate the average
    const averageAge: number = Math.round(sum / ages.length);

    return averageAge;
};